import { getTime, getUnixTime } from 'date-fns';

import { parseDateInput } from './parseDateInput';

type OptionsType = {
  format?: string;
  unit?: 'seconds' | 'milliseconds';
};
/**
 * Преобразует входное значение даты в Unix timestamp.
 *
 * Сначала парсит input в Date с указанным форматом.
 * Если дату невозможно распарсить — возвращает null.
 *
 * @example
 * formatInputToTimestamp('01.01.2024', { format: 'dd.MM.yyyy' })
 * // → 1704067200000
 *
 * @example
 * formatInputToTimestamp('01.01.2024', {
 *   format: 'dd.MM.yyyy',
 *   unit: 'seconds'
 * })
 * // → 1704067200
 */
export function formatInputToTimestamp(
  input: unknown,
  { format, unit = 'milliseconds' }: OptionsType = {},
): number | null {
  const date = parseDateInput(input, { format });

  if (!date) {
    return null;
  }

  return unit === 'seconds' ? getUnixTime(date) : getTime(date);
}
